import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import M_GUIDE_BASIC from './M_GUIDE_BASIC';

export default function M_GUIDE_BASICF() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('매뉴얼 목록'));
  }, [dispatch]);

  return (
    <div
      className="wrap"
      style={{
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <M_GUIDE_BASIC />
    </div>
  );
}
